import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { IoCheckmarkCircle, IoClose } from "react-icons/io5";
import { FamilyConsentTerms } from "./FamilyConsent";
import { formatConsentAcceptedAt } from "../../common/utils/familyPortalConsent";

const AGREEMENT_VERSION = "1.0";

const FamilyAgreementDialog = ({ open, onClose, consentAcceptedAt }) => {
  const acceptedDate = formatConsentAcceptedAt(consentAcceptedAt);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper" className="family-agreement-dialog" aria-labelledby="family-agreement-dialog-title" PaperProps={{ className: "family-settings-dialog-paper family-agreement-dialog-paper" }}>
      <DialogTitle className="family-agreement-dialog-header">
        <span className="family-agreement-dialog-heading">
          <span id="family-agreement-dialog-title" className="family-modal-title">
            Confidentiality &amp; Authorized Access
          </span>
          <span className="family-agreement-version">Agreement version: {AGREEMENT_VERSION}</span>
        </span>
        <button type="button" className="family-modal-close" onClick={onClose} aria-label="Close">
          <IoClose />
        </button>
      </DialogTitle>

      <DialogContent dividers className="family-agreement-dialog-content">
        <p className="family-agreement-accepted" role="status">
          <IoCheckmarkCircle aria-hidden="true" />
          <span>{acceptedDate ? `You agreed and certified on ${acceptedDate}` : "You have agreed and certified"}</span>
        </p>

        <div className="family-consent-body family-agreement-body">
          <FamilyConsentTerms accepted />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FamilyAgreementDialog;
